module.exports = __webpack_public_path__ + "static/media/customize-icon.a8bcbec7.svg";